import { IconButton, InputAdornment, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ChangeEvent, ChangeEventHandler, KeyboardEventHandler } from 'react';

const styles = makeStyles({
    title: {
        fontFamily: "Sarabun",
        textTransform: 'initial',
        fontSize: '16px',
        fontWeight: 600,
        color: '#000000',
        marginTop: '10px'
    },
    placeholder: {
        fontFamily: "Sarabun",
        fontWeight: 'lighter',
        textTransform: 'initial',
        fontSize: '10px',
        color: '#4D4D4D;',
        verticalAlign: "middle"
    },
    input: {
        border: "solid 1px #56617F",
        marginTop: "10px"
    },
    container: {
        margin: "10px 10px",
    },
    visibilityButton: {
        position: 'absolute',
        top: '50%',
        right: '10px',
        cursor: 'pointer',
    },
    inputContainer: {
        width: "100%",
        position: 'relative',
    },
});

interface InputProps {
    title: string;
    colorTitle?: string;
    placeholder: string;
    disabled?: boolean;
    onChange?: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>
    onKeyUp?: KeyboardEventHandler<HTMLDivElement> | undefined;
    value?: string;
    type?: string;
    showPassword: boolean;
    changeVisibility: Function;
}

const Input = ({
    type,
    disabled = false,
    placeholder,
    title,
    colorTitle,
    onChange,
    onKeyUp,
    value,
    showPassword,
    changeVisibility
}: InputProps) => {
    const classes = styles();

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
                        /*
                          Caracteres eliminados:
                          \u0022 - "  (Comilla doble)
                          \u0027 - '  (Comilla simple)
                          \u201C - “  (Comilla doble izquierda)
                          \u201D - ”  (Comilla doble derecha)
                          \u2018 - ‘  (Comilla simple izquierda)
                          \u2019 - ’  (Comilla simple derecha)
                          \u2032 - ′  (Prime, comilla simple en matemáticas)
                          \u2033 - ″  (Double Prime, comilla doble en matemáticas)
                          \u00B4 - ´  (Acento agudo)
                          \u003C - <  (Menor que)
                          \u003E - >  (Mayor que)
                          \u002F - /  (Barra inclinada)
                          \u005C - \  (Barra invertida)
                          \u0026 - &  (Ampersand)
                          \u0025 - %  (Porcentaje)
                          \u003F - ?  (Signo de interrogación)
                          \u003D - =  (Signo de igual)
                        */
        const filteredValue = e.target.value.replace(
            /[\u0022\u0027\u201C\u201D\u2018\u2019\u2032\u2033\u00B4\u003C\u003E\u002F\u005C\u0026\u0025\u003F\u003D]/g,
            ''
        );
        onChange?.({ ...e, target: { ...e.target, value: filteredValue } });
    };

    return (
        <div className={classes.container}>
            <span
                style={{ color: colorTitle }}
                className={classes.title}
            >
                {title}
            </span>
            <div className={classes.inputContainer}>
                <TextField
                    type={showPassword ? 'text' : type ? type : 'text'}
                    value={value}
                    disabled={disabled}
                    fullWidth
                    onChange={handleChange}
                    onKeyUp={onKeyUp}
                    placeholder={placeholder}
                    InputProps={{
                        className: classes.input, // Aplicamos la clase de estilo aquí
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    className={classes.visibilityButton}
                                    onClick={() => changeVisibility()}
                                >
                                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
        </div>
    );
};

export default (Input);
